
import { useState, useContext, useEffect, useRef } from "react";
import React from "react";
import Navbar from "../Home/navbar/Navbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ordersLink } from "../../routes/routes";
import SellerType from "../UI/StoreManagerForm/SellerType";
import UploadDocuments from "../UI/StoreManagerForm/UploadDocuments";
import RegisterPricingPlan from "../UI/StoreManagerForm/RegisterPricingPlan";
import {
  aadharDocumentSubmitApi,
  addSellerTypeApi,
  dlDocumentSubmitApi,
  gstDocumentSubmitApi,
  passportDocumentSubmitApi,
} from "../../Apis/StoreApi";
import { getAccountTypeApi } from "../../Apis/UserApi";
import { signOut } from "@firebase/auth";
import { UserAuthContext } from "../../App";


const BuyerProfile = () => {
  const [showPopup, setShowPopup] = useState(false);
  const { userUid, isLoggedIn } = useContext(UserAuthContext);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [isStoreVisible, setIsStoreVisible] = useState(false);
  // step 1: Selection of seller type
  const [sellerType, setSellerType] = useState(null);
  const [typeError, setTypeError] = useState("");

  // Step 2 :- UploadDocuments
  const [currentStep, setCurrentStep] = useState(1);
  const [gstVerify, setGstVerify] = useState(null);
  const [aadharVerify, setAadharVerify] = useState(null);
  const [passportVerify, setPassportVerify] = useState(null);
  const [licenseVerify, setLicenseVerify] = useState(null);
  const [error, setError] = useState("");

  // Step 3: Pricing Plan selection
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planError, setPlanError] = useState("");

  const popupRef = useRef(null);

  useEffect(() => {
    const getUserType = async () => {
      const response = await getAccountTypeApi();
      const isSeller = response?.profileData?.accountType === "seller";
      setIsStoreVisible(isSeller);
    };
    getUserType();
  }, []);

  const uploadDocuments = () => {
    if (!gstVerify) {
      setError("GST is mandatory");
      return;
    }

    if (!aadharVerify && !passportVerify && !licenseVerify) {
      setError(
        "Please provide at least one of the following: Aadhar Card, Passport, or Driving License."
      );
      return;
    }

    return 1;
  };

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  const handleLogout = () => {
    navigate("/Login"); // Redirect to login page
  };

  const toggleLogoutPopup = () => {
    setShowLogoutPopup(!showLogoutPopup);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowPopup(false);
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  const steps = [
    {
      title: "Select Seller Type",
      content: (
        <SellerType
          sellerType={sellerType}
          setSellerType={setSellerType}
          typeError={typeError}
          setTypeError={setTypeError}
        />
      ),
    },
    {
      title: "Step 2",
      content: (
        <UploadDocuments
          gstVerify={gstVerify}
          aadharVerify={aadharVerify}
          passportVerify={passportVerify}
          licenseVerify={licenseVerify}
          setGstVerify={setGstVerify}
          setAadharVerify={setAadharVerify}
          setPassportVerify={setPassportVerify}
          setLicenseVerify={setLicenseVerify}
          error={error}
          setError={setError}
        />
      ),
    },
    {
      title: "Step 3",
      content: (
        <RegisterPricingPlan
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          planError={planError}
          setPlanError={setPlanError}
        />
      ),
    },
  ];

  const handleNext = async () => {
    if (currentStep === 1) {
      if (!sellerType) {
        setTypeError("Please select a seller type");
        return;
      }
    }

    // upload documents status
    if (currentStep === 2) {
      const value = uploadDocuments();
      if (value !== 1) return;
    }

    if (currentStep === 3) {
      if (!(typeof selectedPlan === "number")) {
        setPlanError("Please select a plan");
        return;
      }

      // upload document if exist
      try {
        if (gstVerify) await gstDocumentSubmitApi(gstVerify);
        if (aadharVerify) await aadharDocumentSubmitApi(aadharVerify);
        if (passportVerify) await passportDocumentSubmitApi(passportVerify);
        if (licenseVerify) await dlDocumentSubmitApi(licenseVerify);

        await addSellerTypeApi(sellerType);
      } catch (err) {
        console.error(err);
      }

      setShowPopup(false);
      navigate('/sellerDashboard/SellerDashboard');
      return;
    }

    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const togglePopUp = () => {
    setShowPopup(!showPopup);
  };

  const storeManagerDisabledToggle = () => { };

  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/orders" || pathname === "/orders/") {
      navigate("/orders/orderList");
    }
  }, [pathname, navigate]);

  return (
    <>
      <Navbar />
      <div className="w-full h-[677px] flex items-center justify-center drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
        <div className="w-[1240px] h-[590px] bg-[#FFF9F2] rounded-[10px] flex flex-row">
          <div className="w-[226px] h-full bg-white rounded-l-[10px] flex items-center justify-center">
            <div className="flex flex-col gap-y-[3px] w-[226px] h-[490px] overflow-y-auto">
              {ordersLink.map((item, index, isLink) => {
                if (item.isStoreManager && !isStoreVisible) {
                  return null; // Don't render this item
                }

                return (
                  <div
                    key={index}
                    className={[
                      "flex space-x-3 rounded" +
                      (pathname.includes(item.url)
                        ? " bg-[#FFE3C7] text-black font-semibold space-x-2 text-[14px]"
                        : ""),
                    ].join(" ")}
                    onClick={() => {
                      if (item.isStoreManager) {
                        setShowPopup(true);
                      } else if (item.isLogout) {
                        toggleLogoutPopup();
                      } else {
                        navigate(item.url);
                      }
                    }}
                  >
                    <div className="flex w-[226px] h-[46px] items-center justify-start">
                      <button className="flex items-center justify-start select-none w-[226px] h-[46px]">
                        <hr
                          className={
                            pathname.includes(item.url)
                              ? "bg-[#FF6300] w-[3px] h-[46px] rounded-full"
                              : ""
                          }
                        />
                        <img
                          className="w-[20px] h-[20px] ml-[23px] mr-[15px]"
                          src={item.img}
                          alt=""
                        />
                        <div className="flex items-center justify-between w-[150px] text-[14px] font-regular">
                          {item.type}
                        </div>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <Outlet />
        </div>
      </div>

      {showPopup && (
        <div className="absolute inset-0 bg-gray-500 bg-opacity-75 overflow-auto h-[1097px] w-full flex justify-center items-center">
          <div className="w-[1055px] h-auto rounded-[20px] bg-white flex flex-col py-[40px] px-[30px] items-center justify-start" ref={popupRef}>
            <div className="">{steps[currentStep - 1].content}</div>

            <div className="flex flex-col items-center justify-start w-[482px] h-[103px]">
              <div className="flex gap-x-[7px] h-[8px] items-center justify-center w-[482px]">
                <hr
                  className={`progress-bar-step h-[8px] w-[156px] rounded-full ${currentStep >= 1 ? "bg-[#FF6300]" : "bg-[#FFE3C7]"
                    }`}
                ></hr>
                <hr
                  className={`progress-bar-step h-[8px] w-[156px] rounded-full ${currentStep >= 2 ? "bg-[#FF6300]" : "bg-[#FFE3C7]"
                    }`}
                ></hr>
                <hr
                  className={`progress-bar-step h-[8px] w-[156px] rounded-full ${currentStep >= 3 ? "bg-[#FF6300]" : "bg-[#FFE3C7]"
                    }`}
                ></hr>
              </div>
              <p className="w-[32px] h-[21px] font-medium text-[14px] text-black mt-[11px]">
                {currentStep} / 3
              </p>
              <div className="w-[214px] h-[41px] flex flex-row items-center justify-between mt-[22px]">
                <button
                  className="w-[100px] h-[41px] flex items-center justify-center font-semibold text-[14px] text-black rounded-[5px] border"
                  onClick={handlePrev}
                  disabled={currentStep === 1}
                >
                  Back
                </button>

                <button
                  className="w-[100px] h-[41px] font-semibold text-[14px] text-white flex items-center justify-center rounded-[5px] bg-[#FF6300]"
                  onClick={handleNext}
                  disabled={currentStep === steps.length + 1}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLogoutPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-[563px] h-[308px] rounded-[10px] bg-white flex flex-col items-center justify-center shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
            <p className="w-[124px] h-[124px] rounded-full bg-[#FEECD4] flex items-center justify-center">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1570_19058)">
                  <mask
                    id="mask0_1570_19058"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="48"
                    height="48"
                  >
                    <path d="M0 0H47.5V47.5H0V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_1570_19058)">
                    <path
                      d="M27.5 42C27.5 42.9946 27.1049 43.9484 26.4017 44.6517C25.6984 45.3549 24.7446 45.75 23.75 45.75C22.7554 45.75 21.8016 45.3549 21.0983 44.6517C20.3951 43.9484 20 42.9946 20 42C20 41.0054 20.3951 40.0516 21.0983 39.3483C21.8016 38.6451 22.7554 38.25 23.75 38.25C24.7446 38.25 25.6984 38.6451 26.4017 39.3483C27.1049 40.0516 27.5 41.0054 27.5 42Z"
                      fill="black"
                    />
                    <path
                      d="M27.5 30C27.5 30.9946 27.1049 31.9484 26.4017 32.6517C25.6984 33.3549 24.7446 33.75 23.75 33.75C22.7554 33.75 21.8016 33.3549 21.0983 32.6517C20.3951 31.9484 20 30.9946 20 30V6.25C20 5.25544 20.3951 4.30161 21.0983 3.59835C21.8016 2.89509 22.7554 2.5 23.75 2.5C24.7446 2.5 25.6984 2.89509 26.4017 3.59835C27.1049 4.30161 27.5 5.25544 27.5 6.25V30Z"
                      fill="black"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_1570_19058">
                    <rect width="47.5" height="47.5" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </p>

            <p className="w-[253px] h-[23px] text-black font-semibold text-[15px] mt-[26px]">
              Are you sure you want to logout?
            </p>

            <div className="flex flex-row gap-x-[19px] mt-[26px]">
              <button
                className="w-[95px] h-[42px] rounded-[10px] font-medium text-[14px] flex items-center justify-center border shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]"
                onClick={() => {
                  signOut(userUid);
                  handleLogout()
                  deleteCookie("token");
                }}>
                Yes
              </button>

              <button
                className="w-[99px] h-[42px] font-semibold text-[14px] bg-[#FF6300] text-white rounded-[10px]"
                onClick={toggleLogoutPopup}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BuyerProfile;
